<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4>Remove Exception Range</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <form>
          <div class="form-group">
            <label>Start Date</label> <br>
            <datepicker format="MM/dd/yyyy" inputClass="form-control" placeholder="Select Start Date"
                        v-model="exception_data.start_date"></datepicker>
          </div>
          <div class="form-group">
            <label>End Date</label> <br>
            <datepicker format="MM/dd/yyyy" inputClass="form-control" placeholder="Select End Date"
                        v-model="exception_data.end_date"></datepicker>
          </div>
          <button type="button" class="btn btn-hub-primary" @click="submit()">Submit</button>
          <router-link :to="{ name: 'CalendarScheduler' }" class="btn btn-secondary">Cancel</router-link>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'

export default {
  data: function () {
    return {
      exception_data: {
        start_date: new Date(),
        end_date: new Date(),
        selected_day_schedules: [],
        exception_type: 1
      }
    }
  },
  computed: {},
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', true)
  },
  components: { Datepicker },
  methods: {
    submit () {
      this.$store.dispatch('modifyExceptionRange', { ...this.exception_data, push_on_success: 'CalendarScheduler' })
    }
  }
}
</script>

<style scoped>

</style>
